/* eslint-disable radix */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-lonely-if */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-alert */
/* eslint-disable no-undef */
/* eslint-disable curly */
import React, { useState } from 'react';
import { myLeadsState } from 'Stores/myLeads';
import makeApi, { URLS } from 'Utils/apiUtil';
import { userDetail } from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import { MX_EVENTS_AE } from 'Utils/constants';
import AddToSequencePopup from 'Components/salesgear/sequence/AddToSequencePopup';
import BulkContactValidationPopup from 'Components/salesgear/sequence/BulkValidationPopup';
import { purchaseStatusPopupState } from '../common/purchaseStatusPopup';
import SelectExportType from './SelectExportType';

const SalesgearExportCRM = props => {
  const {
    hide,
    option,
    upgrade,
    loader,
    resultResponse,
    limit,
    showConnectInbox,
    clearSelectedFields,
  } = props;

  const [addSequence, setAddSequence] = useState(true);
  const [showAeSequencePopup, setShowAeSequencePopup] = useState(false);
  const [addContact, setAddContact] = useState(false);
  const [selectExport, setSelectedExport] = useState('sequences');
  const [exportData, setExportData] = useState('');
  const [
    showBulkContacValidationPopup,
    setShowBulkContacValidationPopup,
  ] = useState(false);

  const [selectedSeqId, setSelectedSeqId] = useState('');

  const closePopup = () => {
    clearSelectedFields && clearSelectedFields();
    hide(false);
  };

  const getToogleValue = (evnt, id) => {
    if (id === 'addToSeq') {
      setSelectedExport('sequences');
      setAddSequence(!addSequence);
      setAddContact(false);
    } else {
      setSelectedExport('contacts');
      setAddContact(!addContact);
      setAddSequence(false);
    }
  };

  const checkExportLimit = () => {
    if (myLeadsState.leadsResultCount > 5000) {
      return false;
    }
    return true;
  };

  const getContactsIdToExport = () => {
    const payload = {};
    if (option === 'export selected') {
      payload.contactIds = Utils.extractValuesFromObject(
        myLeadsState.bulkPurchaseIds,
      );
    } else if (myLeadsState.selectedList.name !== 'All Leads') {
      if (checkExportLimit()) {
        payload.listId = myLeadsState.selectedList.id;
      } else {
        limit(myLeadsState.leadsResultCount);
        return false;
      }
    } else {
      if (checkExportLimit()) {
        payload.listId = 'all';
      } else {
        limit(myLeadsState.leadsResultCount);
        return false;
      }
    }
    return payload;
  };

  const upgradePopupLB = () => {
    loader(false);
    if (
      userDetail.userInfo.memberSubscription !== null &&
      userDetail.userInfo.memberSubscription !== undefined
    ) {
      Utils.showCreditExpiredPopup('downloads');
    } else {
      Utils.showUserPricingPopup(true, 'downloads', false);
    }
  };

  const upgradePopupAE = (data, exportSuccess) => {
    const value = {
      name: 'export',
      exportSuccess,
    };
    if (Object.keys(data).length > 0) {
      if (data.contactIds && data.contactIds.length > 0) {
        value.count = data.contactIds.length;
      } else {
        value.count = myLeadsState.leadsResultCount;
      }
    }
    upgrade(value);
  };

  const reduceDownloads = res => {
    const { downloads, lbCredits } = userDetail.userInfo;
    const { newDownloadedCount, creditsReduced } = res;

    if (Utils.isCreditBasedSubscription()) {
      const reducedCount = creditsReduced && parseInt(creditsReduced);
      if (lbCredits && lbCredits >= reducedCount) {
        userDetail.updateUserInfo({
          lbCredits: lbCredits - reducedCount,
        });
      }
    } else {
      const reducedCount = newDownloadedCount && parseInt(newDownloadedCount);
      if (downloads && downloads >= reducedCount) {
        userDetail.updateUserInfo({
          downloads: downloads - reducedCount,
        });
      }
    }
  };

  const exportToContacts = async (data = {}) => {
    try {
      const config = {
        url: URLS.salesgear.exportToContact,
        method: 'POST',
        data,
      };

      const res = await makeApi(config);
      if (
        res &&
        res.data &&
        Object.keys(res).length > 0 &&
        res.data.status === 200 &&
        res.data.errorType !== 'LIMIT_REACHED'
      ) {
        reduceDownloads(res.data);
        resultResponse(res.data);
      } else if (res.data.status === 101) {
        upgradePopupLB();
      } else if (
        res.data.status === 509 ||
        res.data.errorType === 'LIMIT_REACHED'
      ) {
        if (res.data.exportSuccessCount > 0) {
          reduceDownloads(res.data);
          upgradePopupAE(data, res.data.exportSuccessCount);
        } else {
          upgrade('');
        }
      } else {
        resultResponse('failed', res.data);
      }
      console.log(res);
    } catch (err) {
      console.error(err, 'Failed to Export Contact in SALESGEAR CRM');
    }
  };

  const showSequencePopup = data => {
    setShowAeSequencePopup(true);
    setExportData(data);
  };

  const continueExport = () => {
    if (selectExport === 'sequences') {
      showSequencePopup(getContactsIdToExport());
      Utils.mixpanelTrack(MX_EVENTS_AE.addSequenceClicked, {
        type: selectExport,
      });
    } else {
      loader(true);
      Utils.mixpanelTrack(MX_EVENTS_AE.addContactClicked, {
        type: selectExport,
      });
      exportToContacts(getContactsIdToExport());
    }
  };

  const handleSequenceResponse = res => {
    const respData = res && res.data;
    const respStatus = respData && respData.status;
    const respErrorType = respData && respData.errorType;
    const respSuccessCount = respData && respData.exportSuccessCount;
    if (respData && respStatus === 200 && respErrorType === null) {
      reduceDownloads(respData);
      resultResponse(respData);
      if (respSuccessCount) {
        Utils.mixpanelTrack(MX_EVENTS_AE.addedToSequence);
        Utils.mixpanelTrack(MX_EVENTS_AE.aeSequenceStarted, {
          pageType: 'Lead Builder',
        });
      }
    } else if (respStatus === 101) {
      upgradePopupLB();
    } else if (respStatus === 509 || respErrorType === 'LIMIT_REACHED') {
      if (respData.exportSuccessCount > 0) {
        reduceDownloads(respData);
        upgradePopupAE(data, respData.exportSuccessCount);
      } else {
        upgrade('');
      }
    } else if (respErrorType === 'FROM_ADDRESS_EMPTY') {
      showConnectInbox(true);
    } else if (respErrorType === 'SEQUENCE_EMPTY_STAGE') {
      loader(false);
      purchaseStatusPopupState.setToastMsg(
        null,
        null,
        null,
        null,
        null,
        'Add stages before adding contacts to a sequence',
      );
    } else {
      resultResponse('failed', respData);
    }
  };

  const showBulkValiationPopup = async selectedSequeceId => {
    if (exportData) {
      setShowAeSequencePopup(false);
      setSelectedSeqId(selectedSequeceId);
      setShowBulkContacValidationPopup(true);
    }
  };

  const bulkContactAddToSeq = async validContacts => {
    if (validContacts && validContacts.length) {
      try {
        loader(true);
        const payload = {
          contactIds: validContacts,
          sequenceId: selectedSeqId,
          openTrack: true,
          linkTrack: true,
          force: true,
        };
        const config = {
          url: URLS.salesgear.exportToContact,
          method: 'POST',
          data: payload,
        };
        const res = await makeApi(config);
        clearSelectedFields && clearSelectedFields();
        if (res && res.status === 200) {
          handleSequenceResponse(res);
        } else {
          resultResponse('failed', res.data);
        }
      } catch (err) {
        console.error(err, 'Failed to add contact sequence');
      }
    } else {
      resultResponse('failed', {});
    }
  };

  return showAeSequencePopup ? (
    <AddToSequencePopup
      closePopup={closePopup}
      submitCbk={showBulkValiationPopup}
    />
  ) : showBulkContacValidationPopup ? (
    <BulkContactValidationPopup
      bulkContactAddToSeq={bulkContactAddToSeq}
      contactIds={exportData}
      closePopup={closePopup}
      exportData={exportData}
      selectedSeqId={selectedSeqId}
      handleSequenceResponse={handleSequenceResponse}
    />
  ) : (
    <SelectExportType
      closePopup={closePopup}
      addSequence={addSequence}
      getToogleValue={getToogleValue}
      addContact={addContact}
      continueExport={continueExport}
    />
  );
};

export default SalesgearExportCRM;
